module.exports = __webpack_public_path__ + "static/media/facebook-icon.4b00de0b.svg";